import React from 'react';
import { Link } from 'react-router-dom';
import './AutomotivePage.css';

  const services = [
    {
    title: 'Skin & Eye Care Film',
    description: 'Blocks harmful UV rays, reduces glare, and protects skin and eyes for a safer, more comfortable driving experience.',
    link: '/skin-eye-care'
    },
    {
    title: 'Nano Ceramic Film',
    description: 'Advanced ceramic technology for maximum heat rejection, signal clarity, and long-lasting performance in all weather conditions.',
    link: '/nano-ceramic'
    },
    {
    title: 'Platinum Signature',
    description: 'Premium window film with luxury aesthetics, superior clarity, and high-performance solar and UV protection for your vehicle.',
    link: '/platinum-signature'
    },
    {
    title: 'Reflective Film',
    description: 'Reflects solar energy, enhances privacy, and keeps your car cool while maintaining a sleek, modern appearance.',
    link: '/reflective-film'
    },
    {
    title: 'Windshield Protection',
    description: 'Protects your windshield from chips, cracks, and road debris, ensuring clear vision and long-term durability.',
    link: '/windshield-protection'
    },
    {
    title: 'Pre-Cut Films',
    description: 'Precision-cut window films for easy installation, perfect fit, and professional results on any vehicle make or model.',
    link: '/pre-cut-films'
  }
];

const serviceImages = [
  'https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=800&q=80', // Skin & Eye Care Film
  'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=800&q=80', // Nano Ceramic Film
  'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=800&q=80', // Platinum Signature
  'https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80', // Reflective Film
  'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=800&q=80', // Windshield Protection
  'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=800&q=80', // Pre-Cut Films (car image)
];

const AutomotivePage = () => {
  return (
    <div className="automotive-main">
      <section className="architectural-top custom-arch-top">
        <div className="arch-top-overlay" />
        <div className="arch-top-diagonal" />
        <div className="architectural-top-content">
          <h1>Automotive Solutions</h1>
        </div>
      </section>

      <section className="arch-services-section">
        <h2 className="arch-services-title">Our Automotive Services</h2>
        <div className="arch-services-list">
          {services.map((service, idx) => (
            <div className="arch-service-card service-card-overlay" key={idx}>
              <div
                className="service-card-bg"
                style={{
                  background: `url('${serviceImages[idx]}') center center/cover no-repeat`,
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  zIndex: 0,
                  borderRadius: '15px',
                }}
              />
              <div className="service-card-overlay-actual" />
              <div style={{ position: 'relative', zIndex: 2 }}>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <Link to={service.link} className="arch-service-btn">Learn More</Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AutomotivePage; 